// extracted by mini-css-extract-plugin
export var childrenContainer = "_cs-0";
export var virtualScrollArea = "_cs-1";